import { AxiosError } from "axios";
import { fetchTags } from "../../services/menuApp/categoryMenuService";
import {
  fetchCategoriesInfo,
  fetchMenusInfo,
  fetchProductGetByWrapperInfo,
  updateMenuSInfo,
  updateProductWrapperInfo,
  updateWrapperInfo,
} from "../../services/menuApp/menuService";
import {
  fetchGlobalDepartmentInfo,
  fetchGlobalGroupInfo,
  fetchGlobalProductsInfo,
  fetchProductConfigInfo,
  fetchProductWrapperInfo,
} from "../../services/menuApp/printerMenuService";

// Action Types
export const FETCH_MENUS_PENDING = "FETCH_MENUS_PENDING";
export const FETCH_MENUS_SUCCESS = "FETCH_MENUS_SUCCESS";
export const FETCH_MENUS_ERROR = "FETCH_MENUS_ERROR";

export const FETCH_MENU_DETAILS_PENDING = "FETCH_MENU_DETAILS_PENDING";
export const FETCH_MENU_DETAILS_SUCCESS = "FETCH_MENU_DETAILS_SUCCESS";
export const FETCH_MENU_DETAILS_ERROR = "FETCH_MENU_DETAILS_ERROR";

export const FETCH_PRODUCT_DETAILS_PENDING = "FETCH_PRODUCT_DETAILS_PENDING";
export const FETCH_PRODUCT_DETAILS_SUCCESS = "FETCH_PRODUCT_DETAILS_SUCCESS";
export const FETCH_PRODUCT_DETAILS_ERROR = "FETCH_PRODUCT_DETAILS_ERROR";

export const UPDATE_PRODUCT_PENDING = "UPDATE_PRODUCT_PENDING";
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_ERROR = "UPDATE_PRODUCT_ERROR";

export const UPDATE_DIRECTORY_PENDING = "UPDATE_DIRECTORY_PENDING";
export const UPDATE_DIRECTORY_SUCCESS = "UPDATE_DIRECTORY_SUCCESS";
export const UPDATE_DIRECTORY_ERROR = "UPDATE_DIRECTORY_ERROR";

export const UPDATE_MENU_PENDING = "UPDATE_MENU_PENDING";
export const UPDATE_MENU_SUCCESS = "UPDATE_MENU_SUCCESS";
export const UPDATE_MENU_ERROR = "UPDATE_MENU_ERROR";

export const LOAD_COMMON_DATA_PENDING = "LOAD_COMMON_DATA_PENDING";
export const LOAD_COMMON_DATA_SUCCESS = "LOAD_COMMON_DATA_SUCCESS";
export const LOAD_COMMON_DATA_ERROR = "LOAD_COMMON_DATA_ERROR";

export const CLEAR_MENU_DETAILS = "CLEAR_MENU_DETAILS";
export const CLEAR_DIRECTORY_VIEW = "CLEAR_DIRECTORY_VIEW";
export const CLEAR_PRODUCT = "CLEAR_PRODUCT";
export const CLEAR_ALL_MENU_DATA = "CLEAR_ALL_MENU_DATA";

// Menu Store Actions
export const ADD_MENU_TO_STORE = "ADD_MENU_TO_STORE";
export const UPDATE_MENU_IN_STORE = "UPDATE_MENU_IN_STORE";
export const DELETE_MENU_FROM_STORE = "DELETE_MENU_FROM_STORE";

// Directory Store Actions
export const UPDATE_DIRECTORY_IN_STORE = "UPDATE_DIRECTORY_IN_STORE";

// All Menu Details Actions
export const FETCH_ALL_MENU_DETAILS_SUCCESS = "FETCH_ALL_MENU_DETAILS_SUCCESS";

// In your Redux actions (menu actions file)
export const SET_PRODUCTS_VERSION = "SET_PRODUCTS_VERSION";

export const setProductsVersion = (version: number) => ({
  type: SET_PRODUCTS_VERSION,
  payload: version,
});

// Action Creators for Menu Store
export const addMenuToStore = (menu: any) => ({
  type: ADD_MENU_TO_STORE,
  payload: menu,
});

export const updateMenuInStore = (menu: any) => ({
  type: UPDATE_MENU_IN_STORE,
  payload: menu,
});

export const deleteMenuFromStore = (menuId: number) => ({
  type: DELETE_MENU_FROM_STORE,
  payload: menuId,
});

// Action Creators for Directory Store
export const updateDirectoryInStore = (directory: any) => ({
  type: UPDATE_DIRECTORY_IN_STORE,
  payload: directory,
});

// Action Creators for All Menu Details
export const fetchAllMenuDetailsSuccess = (payload: any) => ({
  type: FETCH_ALL_MENU_DETAILS_SUCCESS,
  payload,
});

// Action Creators
export const fetchMenusPending = () => ({
  type: FETCH_MENUS_PENDING,
});

export const fetchMenusSuccess = (payload: any) => ({
  type: FETCH_MENUS_SUCCESS,
  payload,
});

export const fetchMenusError = (error: any) => ({
  type: FETCH_MENUS_ERROR,
  error,
});

export const fetchMenuDetailsPending = () => ({
  type: FETCH_MENU_DETAILS_PENDING,
});

export const fetchMenuDetailsSuccess = (payload: any) => ({
  type: FETCH_MENU_DETAILS_SUCCESS,
  payload,
});

export const fetchMenuDetailsError = (error: any) => ({
  type: FETCH_MENU_DETAILS_ERROR,
  error,
});

export const fetchProductDetailsPending = () => ({
  type: FETCH_PRODUCT_DETAILS_PENDING,
});

export const fetchProductDetailsSuccess = (payload: any) => ({
  type: FETCH_PRODUCT_DETAILS_SUCCESS,
  payload,
});

export const fetchProductDetailsError = (error: any) => ({
  type: FETCH_PRODUCT_DETAILS_ERROR,
  error,
});

export const updateProductPending = () => ({
  type: UPDATE_PRODUCT_PENDING,
});

export const updateProductSuccess = (payload: any) => ({
  type: UPDATE_PRODUCT_SUCCESS,
  payload,
});

export const updateProductError = (error: any) => ({
  type: UPDATE_PRODUCT_ERROR,
  error,
});

export const updateDirectoryPending = () => ({
  type: UPDATE_DIRECTORY_PENDING,
});

export const updateDirectorySuccess = (payload: any) => ({
  type: UPDATE_DIRECTORY_SUCCESS,
  payload,
});

export const updateDirectoryError = (error: any) => ({
  type: UPDATE_DIRECTORY_ERROR,
  error,
});

export const updateMenuPending = () => ({
  type: UPDATE_MENU_PENDING,
});

export const updateMenuSuccess = (payload: any) => ({
  type: UPDATE_MENU_SUCCESS,
  payload,
});

export const updateMenuError = (error: any) => ({
  type: UPDATE_MENU_ERROR,
  error,
});

export const loadCommonDataPending = () => ({
  type: LOAD_COMMON_DATA_PENDING,
});

export const loadCommonDataSuccess = (payload: any) => ({
  type: LOAD_COMMON_DATA_SUCCESS,
  payload,
});

export const loadCommonDataError = (error: any) => ({
  type: LOAD_COMMON_DATA_ERROR,
  error,
});

export const clearMenuDetails = (menuId: string) => ({
  type: CLEAR_MENU_DETAILS,
  payload: menuId,
});

export const clearDirectoryView = (cacheKey: string) => ({
  type: CLEAR_DIRECTORY_VIEW,
  payload: cacheKey,
});

export const clearProduct = (productId: string) => ({
  type: CLEAR_PRODUCT,
  payload: productId,
});

export const clearAllMenuData = () => ({
  type: CLEAR_ALL_MENU_DATA,
});

// Add this action type with your existing ones
export const UPDATE_CATEGORY_IN_STORE = "UPDATE_CATEGORY_IN_STORE";

// Add this action creator
export const updateCategoryInStore = (category: any) => ({
  type: UPDATE_CATEGORY_IN_STORE,
  payload: category,
});

// Add this action to your redux/actions/menu.ts
export const updateProductWrapperInStore = (wrapperData: any) => {
  return {
    type: "UPDATE_PRODUCT_WRAPPER",
    payload: wrapperData,
  };
};

// Async Action - Fetch all menu details at once
export const fetchAllMenuDetails =
  (locationId: string) => async (dispatch: any) => {
    try {
      // First fetch menus list
      const menusRes = await fetchMenusInfo(locationId);
      const menus = menusRes.data.data;

      const allMenuDetails: any = {};

      // Fetch common data once (reused for all menus)
      const [
        categoriesRes,
        wrapperRes,
        allProductsRes,
        productConfigRes,
        tagsRes,
        departmentsRes,
        groupsRes,
      ] = await Promise.all([
        fetchCategoriesInfo(locationId),
        fetchProductWrapperInfo(locationId),
        fetchGlobalProductsInfo(locationId),
        fetchProductConfigInfo(locationId),
        fetchTags(locationId),
        fetchGlobalDepartmentInfo(locationId),
        fetchGlobalGroupInfo(locationId),
      ]);

      const categories = categoriesRes.data.data;
      const wrappers = wrapperRes.data.data;
      const allProducts = allProductsRes.data.data;
      const productVersionData = productConfigRes.data.data.productsVersion;
      const allergenObject = tagsRes.data.data.reduce(
        (acc: any, current: any) => {
          acc[current.id] = current;
          return acc;
        },
        {},
      );

      const departmentsData = departmentsRes?.data?.data || [];
      const groupsData = groupsRes.data.data || [];

      // Helper functions
      const buildNestedWrapperStructure = (
        wrappers: any[],
        targetDirectoryId: number,
      ): any => {
        const nestedWrapper: any = {};
        const childWrappers = wrappers.filter(
          (w) => w.directoryId === targetDirectoryId,
        );
        childWrappers.forEach((wrapper) => {
          if (wrapper.directory) {
            nestedWrapper[wrapper.id] = {
              ...wrapper,
              wrapper: buildNestedWrapperStructure(wrappers, wrapper.id),
            };
          } else {
            nestedWrapper[wrapper.id] = wrapper;
          }
        });
        return nestedWrapper;
      };

      const getWrapperWithPrice = (wrapper: any, allProducts: any[]) => {
        if (!allProducts || allProducts.length === 0)
          return { ...wrapper, price: null };
        const matchedProducts = allProducts.filter(
          (p: any) => p.itemWrapperId === wrapper.id,
        );
        if (matchedProducts.length === 0) return { ...wrapper, price: "0.00" };
        const prices = matchedProducts.map((p: any) =>
          parseFloat(p.price || 0),
        );
        const minPrice = Math.min(...prices);
        const maxPrice = Math.max(...prices);
        let displayPrice;
        if (prices.length > 1 && minPrice !== maxPrice) {
          displayPrice = `${minPrice.toFixed(2)} - ${maxPrice.toFixed(2)}`;
        } else {
          displayPrice = `${minPrice.toFixed(2)}`;
        }
        return { ...wrapper, price: displayPrice };
      };

      const addPricesToWrappers = (
        wrapperObj: any,
        allProducts: any[],
      ): any => {
        if (!wrapperObj) return wrapperObj;
        const result: any = {};
        for (const key in wrapperObj) {
          const item = wrapperObj[key];
          const itemWithPrice = getWrapperWithPrice(item, allProducts);
          if (item.wrapper) {
            result[key] = {
              ...itemWithPrice,
              wrapper: addPricesToWrappers(item.wrapper, allProducts),
            };
          } else {
            result[key] = itemWithPrice;
          }
        }
        return result;
      };

      // Process each menu
      for (const menu of menus) {
        const menuId = menu.id.toString();
        const selectedMenu = menu;

        const menuStructure: any = {};
        menuStructure[menuId] = { ...selectedMenu, category: {} };
        const wrappersByCategory: any = {};

        wrappers.forEach((wrapper: any) => {
          if (!wrappersByCategory[wrapper.categoryId]) {
            wrappersByCategory[wrapper.categoryId] = [];
          }
          wrappersByCategory[wrapper.categoryId].push(wrapper);
        });

        categories.forEach((category: any) => {
          if (category.menuId === parseInt(menuId)) {
            const categoryWrappers = wrappersByCategory[category.id] || [];
            const wrapperObj: any = {};
            categoryWrappers.forEach((wrapper: any) => {
              if (wrapper.directoryId === -99) {
                if (wrapper.directory) {
                  const nestedStructure = buildNestedWrapperStructure(
                    wrappers,
                    wrapper.id,
                  );
                  wrapperObj[wrapper.id] = {
                    ...wrapper,
                    wrapper: addPricesToWrappers(nestedStructure, allProducts),
                  };
                } else {
                  wrapperObj[wrapper.id] = getWrapperWithPrice(
                    wrapper,
                    allProducts,
                  );
                }
              }
            });
            menuStructure[menuId].category[category.id] = {
              ...category,
              wrapper: wrapperObj,
            };
          }
        });

        allMenuDetails[menuId] = {
          menuNodeList: menuStructure,
          selectedMenuName: selectedMenu?.name || "",
          categoryNode: categories,
          productVersion: productVersionData,
          tags: allergenObject,
          tagList: tagsRes.data.data,
          stockDepartmentSelectedNode: departmentsData,
          stockGroupSelectedNode: groupsData,
          selectedGroupObj: groupsData[0] || {},
        };
        console.log("sdgfdshgsfhdfhsfdf", allMenuDetails);
      }
      console.log("sdgfdshgsfhdfhsfdf 111111", allMenuDetails);

      dispatch(fetchAllMenuDetailsSuccess(allMenuDetails));
    } catch (error) {
      const err: any = error as AxiosError;
      console.error("Error fetching all menu details:", err);
    }
  };

// Async Actions (Thunks)
export const fetchMenus = (locationId: string) => async (dispatch: any) => {
  console.log("sddddddddddddddddfafdasd 222");

  dispatch(fetchMenusPending());
  try {
    const [menusRes, categoriesRes, wrapperRes] = await Promise.all([
      fetchMenusInfo(locationId),
      fetchCategoriesInfo(locationId),
      fetchProductWrapperInfo(locationId),
    ]);

    const menus = menusRes.data.data;
    const categories = categoriesRes.data.data;
    const wrappers = wrapperRes.data.data;

    const wrappersByCategory: any = {};
    wrappers.forEach((wrapper: any) => {
      if (!wrappersByCategory[wrapper.categoryId]) {
        wrappersByCategory[wrapper.categoryId] = [];
      }
      wrappersByCategory[wrapper.categoryId].push(wrapper);
    });

    const countAllWrappers = (wrapperList: any[]): number => {
      let count = 0;
      wrapperList.forEach((wrapper: any) => {
        count++;
        if (wrapper.wrapper && Object.values(wrapper.wrapper).length > 0) {
          count += countAllWrappers(Object.values(wrapper.wrapper));
        }
      });
      return count;
    };

    const categoriesByMenu: any = {};
    const menuStats: any = {};

    menus.forEach((menu: any) => {
      categoriesByMenu[menu.id] = [];
      menuStats[menu.id] = { categoryCount: 0, itemCount: 0 };
    });

    categories.forEach((cat: any) => {
      if (categoriesByMenu[cat.menuId]) {
        categoriesByMenu[cat.menuId].push(cat);
      }
    });

    menus.forEach((menu: any) => {
      const menuCategories = categoriesByMenu[menu.id] || [];
      let totalItems = 0;
      menuCategories.forEach((cat: any) => {
        const categoryWrappers = wrappersByCategory[cat.id] || [];
        totalItems += countAllWrappers(categoryWrappers);
      });
      menuStats[menu.id] = {
        categoryCount: menuCategories?.length,
        itemCount: totalItems,
      };
    });

    dispatch(
      fetchMenusSuccess({
        menus,
        categoriesInfo: menuStats,
        categories,
      }),
    );
  } catch (error) {
    const err: any = error as AxiosError;
    dispatch(fetchMenusError(err.message || "Error fetching menus"));
  }
};

export const fetchMenuDetails =
  (locationId: string, menuId: string) => async (dispatch: any) => {
    dispatch(fetchMenuDetailsPending());
    try {
      const [
        menusRes,
        categoriesRes,
        wrapperRes,
        allProductsRes,
        productConfigRes,
        tagsRes,
        departmentsRes,
        groupsRes,
      ] = await Promise.all([
        fetchMenusInfo(locationId),
        fetchCategoriesInfo(locationId),
        fetchProductWrapperInfo(locationId),
        fetchGlobalProductsInfo(locationId),
        fetchProductConfigInfo(locationId),
        fetchTags(locationId),
        fetchGlobalDepartmentInfo(locationId),
        fetchGlobalGroupInfo(locationId),
      ]);

      const menus = menusRes.data.data;
      const selectedMenu = menus.find((m: any) => m.id === parseInt(menuId));
      const categories = categoriesRes.data.data;
      const wrappers = wrapperRes.data.data;
      const allProducts = allProductsRes.data.data;
      const productVersionData = productConfigRes.data.data.productsVersion;

      const allergenObject = tagsRes.data.data.reduce(
        (acc: any, current: any) => {
          acc[current.id] = current;
          return acc;
        },
        {},
      );

      const departmentsData = departmentsRes?.data?.data || [];
      const groupsData = groupsRes.data.data || [];

      const buildNestedWrapperStructure = (
        wrappers: any[],
        targetDirectoryId: number,
      ): any => {
        const nestedWrapper: any = {};
        const childWrappers = wrappers.filter(
          (w) => w.directoryId === targetDirectoryId,
        );
        childWrappers.forEach((wrapper) => {
          if (wrapper.directory) {
            nestedWrapper[wrapper.id] = {
              ...wrapper,
              wrapper: buildNestedWrapperStructure(wrappers, wrapper.id),
            };
          } else {
            nestedWrapper[wrapper.id] = wrapper;
          }
        });
        return nestedWrapper;
      };

      const getWrapperWithPrice = (wrapper: any, allProducts: any[]) => {
        if (!allProducts || allProducts.length === 0)
          return { ...wrapper, price: null };
        const matchedProducts = allProducts.filter(
          (p: any) => p.itemWrapperId === wrapper.id,
        );
        if (matchedProducts.length === 0) return { ...wrapper, price: "0.00" };
        const prices = matchedProducts.map((p: any) =>
          parseFloat(p.price || 0),
        );
        const minPrice = Math.min(...prices);
        const maxPrice = Math.max(...prices);
        let displayPrice;
        if (prices.length > 1 && minPrice !== maxPrice) {
          displayPrice = `${minPrice.toFixed(2)} - ${maxPrice.toFixed(2)}`;
        } else {
          displayPrice = `${minPrice.toFixed(2)}`;
        }
        return { ...wrapper, price: displayPrice };
      };

      const addPricesToWrappers = (
        wrapperObj: any,
        allProducts: any[],
      ): any => {
        if (!wrapperObj) return wrapperObj;
        const result: any = {};
        for (const key in wrapperObj) {
          const item = wrapperObj[key];
          const itemWithPrice = getWrapperWithPrice(item, allProducts);
          if (item.wrapper) {
            result[key] = {
              ...itemWithPrice,
              wrapper: addPricesToWrappers(item.wrapper, allProducts),
            };
          } else {
            result[key] = itemWithPrice;
          }
        }
        return result;
      };

      const menuStructure: any = {};
      menuStructure[menuId] = { ...selectedMenu, category: {} };
      const wrappersByCategory: any = {};

      wrappers.forEach((wrapper: any) => {
        if (!wrappersByCategory[wrapper.categoryId]) {
          wrappersByCategory[wrapper.categoryId] = [];
        }
        wrappersByCategory[wrapper.categoryId].push(wrapper);
      });

      categories.forEach((category: any) => {
        if (category.menuId === parseInt(menuId)) {
          const categoryWrappers = wrappersByCategory[category.id] || [];
          const wrapperObj: any = {};
          categoryWrappers.forEach((wrapper: any) => {
            if (wrapper.directoryId === -99) {
              if (wrapper.directory) {
                const nestedStructure = buildNestedWrapperStructure(
                  wrappers,
                  wrapper.id,
                );
                wrapperObj[wrapper.id] = {
                  ...wrapper,
                  wrapper: addPricesToWrappers(nestedStructure, allProducts),
                };
              } else {
                wrapperObj[wrapper.id] = getWrapperWithPrice(
                  wrapper,
                  allProducts,
                );
              }
            }
          });
          menuStructure[menuId].category[category.id] = {
            ...category,
            wrapper: wrapperObj,
          };
        }
      });

      dispatch(
        fetchMenuDetailsSuccess({
          menuId,
          data: {
            menuNodeList: menuStructure,
            selectedMenuName: selectedMenu?.name || "",
            categoryNode: categories,
            productVersion: productVersionData,
            tags: allergenObject,
            stockDepartmentSelectedNode: departmentsData,
            stockGroupSelectedNode: groupsData,
            selectedGroupObj: groupsData[0] || {},
          },
        }),
      );
    } catch (error) {
      const err: any = error as AxiosError;
      dispatch(
        fetchMenuDetailsError(err.message || "Error fetching menu details"),
      );
    }
  };

export const fetchProductDetails =
  (locationId: string, productId: string) => async (dispatch: any) => {
    dispatch(fetchProductDetailsPending());
    console.log("sddddddddddddddddfafdasd 44444444");
    try {
      const [menuRes, categoriesRes, wrapperRes, departmentsRes] =
        await Promise.all([
          fetchMenusInfo(locationId),
          fetchCategoriesInfo(locationId),
          fetchProductWrapperInfo(locationId),
          fetchGlobalDepartmentInfo(locationId),
        ]);

      const menus = menuRes.data.data;
      const categories = categoriesRes.data.data;
      const wrappers = wrapperRes.data.data;
      const departmentsData = departmentsRes?.data?.data || [];

      const findProductWrapper = (
        wrapperList: any[],
        targetProductId: number,
      ): any => {
        for (const wrapper of wrapperList) {
          if (wrapper.id === targetProductId) return wrapper;
          if (wrapper.wrapper && Object.values(wrapper.wrapper).length > 0) {
            const found = findProductWrapper(
              Object.values(wrapper.wrapper),
              targetProductId,
            );
            if (found) return found;
          }
        }
        return null;
      };

      const foundWrapper = findProductWrapper(wrappers, parseInt(productId));
      if (foundWrapper) {
        const actualCategoryId =
          typeof foundWrapper.categoryId === "object"
            ? foundWrapper.categoryId.id
            : foundWrapper.categoryId;
        const category = categories.find((c: any) => c.id === actualCategoryId);
        const productRes = await fetchProductGetByWrapperInfo(
          locationId,
          foundWrapper.id,
        );

        if (productRes?.data?.data && productRes.data.data.length > 0) {
          const product = productRes.data.data[0];
          dispatch(
            fetchProductDetailsSuccess({
              productId,
              data: {
                wrapperData: foundWrapper,
                selectedProduct: productRes.data.data,
                productData: product,
                selectedMenuName:
                  menus.find((m: any) => m.id === category?.menuId)?.name || "",
                categoryName: category?.name || "",
                categoryId: actualCategoryId,
                stockDepartmentSelectedNode: departmentsData,
              },
            }),
          );
          return;
        }
      }
      dispatch(fetchProductDetailsSuccess(null));
    } catch (error) {
      const err: any = error as AxiosError;
      dispatch(
        fetchProductDetailsError(
          err.message || "Error fetching product details",
        ),
      );
    }
  };

export const updateProduct =
  (locationId: string, productId: string, body: any) =>
  async (dispatch: any) => {
    dispatch(updateProductPending());
    try {
      const res = await updateProductWrapperInfo(
        locationId,
        body,
        "Menus Changed",
        "",
        "menu",
      );
      dispatch(
        updateProductSuccess({ productId, updatedProduct: res.data.data }),
      );
    } catch (error) {
      const err: any = error as AxiosError;
      dispatch(updateProductError(err.message || "Error updating product"));
    }
  };

export const updateDirectory =
  (locationId: string, body: any) => async (dispatch: any) => {
    dispatch(updateDirectoryPending());
    console.log("sddddddddddddddddfafdasd 66");
    try {
      const res = await updateWrapperInfo(
        locationId,
        body,
        "Menus Changed",
        "",
        "menu",
      );
      dispatch(updateDirectorySuccess({ updatedDirectory: res.data.data }));
    } catch (error) {
      const err: any = error as AxiosError;
      dispatch(updateDirectoryError(err.message || "Error updating directory"));
    }
  };

export const updateMenu =
  (locationId: string, data: any, logBody: any, logAppName: string) =>
  async (dispatch: any) => {
    dispatch(updateMenuPending());
    try {
      const res = await updateMenuSInfo(locationId, data, logBody, logAppName);
      dispatch(updateMenuSuccess({ updatedMenu: res.data.data }));
    } catch (error) {
      const err: any = error as AxiosError;
      dispatch(updateMenuError(err.message || "Error updating menu"));
    }
  };

export const loadCommonData = (locationId: string) => async (dispatch: any) => {
  dispatch(loadCommonDataPending());
  try {
    console.log("sddddddddddddddddfafdasd 888888");
    const [tagsRes, departmentsRes, groupsRes, productConfigRes] =
      await Promise.all([
        fetchTags(locationId),
        fetchGlobalDepartmentInfo(locationId),
        fetchGlobalGroupInfo(locationId),
        fetchProductConfigInfo(locationId),
      ]);

    const allergenObject = tagsRes.data.data.reduce(
      (acc: any, current: any) => {
        acc[current.id] = current;
        return acc;
      },
      {},
    );

    const departmentsData = departmentsRes?.data?.data || [];
    const groupsData = groupsRes.data.data || [];
    const productVersionData = productConfigRes.data.data.productsVersion;

    dispatch(
      loadCommonDataSuccess({
        tags: allergenObject,
        departments: departmentsData,
        groups: groupsData,
        productConfig: productVersionData,
      }),
    );
  } catch (error) {
    const err: any = error as AxiosError;
    dispatch(loadCommonDataError(err.message || "Error loading common data"));
  }
};
